import React from 'react'

import { Button } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

import i18n from 'Pods/Shared/I18n'

import { useSearchSubscription } from '../Context/SearchSubscriptionContext'

function Submit({locale = 'en'}) {
  const { loading, handleSubmit } = useSearchSubscription()
  const subscribe = i18n.t('listingPage.footerBanners.searchSubscription.subscribe', { ns: 'rails', lng: locale })
  const subscribing = i18n.t('listingPage.footerBanners.searchSubscription.subscribing', { ns: 'rails', lng: locale })

  return (
    <Button
      type="primary"
      onClick={handleSubmit}
      customClass="js-auth-control"
      actionType="submit"
      variant="with-icon"
      disabled={loading}
    >
      {loading ? subscribing : subscribe}
    </Button>
  )
}

Submit.propTypes = {
  locale: string,
}

export default Submit
